import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "../lib/api";

const AuthCtx = createContext(null);
export const useAuth = () => useContext(AuthCtx);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const r = await api.get("/auth/me");
      setUser(r.data);
    } catch { setUser(null); }
    finally { setLoading(false); }
  }, []);

  useEffect(() => {
    if (window.location.hash?.includes("session_id=")) { setLoading(false); return; }
    refresh();
  }, [refresh]);

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (e) {}
    setUser(null);
  };

  // Emergent Google OAuth redirect
  const loginWithGoogle = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirect = window.location.origin + "/account";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirect)}`;
  };

  // Email + password
  const loginWithPassword = async (email, password) => {
    const r = await api.post("/auth/login", { email, password });
    setUser(r.data);
    return r.data;
  };
  const register = async (email, password, name) => {
    const r = await api.post("/auth/register", { email, password, name });
    setUser(r.data);
    return r.data;
  };
  const forgotPassword = async (email) => api.post("/auth/forgot-password", { email });
  const resetPassword = async (token, password) => api.post("/auth/reset-password", { token, password });
  const sendOtp = async (phone) => api.post("/auth/otp/send", { phone });
  const verifyOtp = async (phone, otp) => {
    const r = await api.post("/auth/otp/verify", { phone, otp });
    // When the phone isn't tied to a registered account yet, the backend
    // returns a `needs_registration` payload instead of a user object.
    if (r.data && r.data.needs_registration) return r.data;
    setUser(r.data);
    return r.data;
  };
  const completeOtpRegistration = async (pending_token, email, name) => {
    const r = await api.post("/auth/otp/complete-registration",
                             { pending_token, email, name });
    setUser(r.data);
    return r.data;
  };

  return (
    <AuthCtx.Provider value={{
      user, loading, refresh, logout, setUser,
      loginWithGoogle, login: loginWithGoogle,  // back-compat
      loginWithPassword, register, forgotPassword, resetPassword,
      sendOtp, verifyOtp, completeOtpRegistration,
    }}>
      {children}
    </AuthCtx.Provider>
  );
}
